module.exports = __webpack_public_path__ + "static/media/chat.fd14947b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/features/chat.mp4
// module id = 367
// module chunks = 0